import { useCallback, useState } from 'react';
import { BottomSheet } from '@/ui/components';
import { Button } from '@/ui/components/Button';
import { ArrowRightIcon } from '@/assets/icons';
import { externalUrls } from '@/constants/urls';
import VoltAppIcon from '@/assets/logos/volt-app-icon.svg';
import styles from './ContinueInAppModal.module.scss';

const title = 'Continuă în aplicație';
const description =
  'Noile produse Volt Zero, One și Infinite sunt disponibile doar în aplicație';

export function useContinueInAppModal() {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const handleDownload = () => {
    window.location.href = externalUrls.volt.appDownload;
  };

  const content = (
    <div className={styles.content}>
      <VoltAppIcon className={styles.appIcon} />
      <div className={styles.textContent}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );

  const footer = (
    <Button
      trackingId="download_app_continue_in_app"
      variant="filled"
      text="Descarcă aplicația Volt"
      rightIcon={<ArrowRightIcon />}
      className={styles.button}
      onClick={handleDownload}
    />
  );

  return {
    open,
    close,
    modal: (
      <BottomSheet
        open={isOpen}
        onOpenChange={setIsOpen}
        ariaLabel={title}
        ariaDescription={description}
        enableDrag
        closeOnOverlay
        footer={footer}
      >
        {content}
      </BottomSheet>
    ),
  };
}
